import React, { Component } from 'react'
import { connect } from 'react-redux'
import './App.css'
import pgnLogo from '../assets/pgn-logo.png'
import { GRAPH_SIZE, NUM_PRODUCTS } from '../store/graphs/constants'
import GraphBlock from './GraphBlock'
import Menu from './Menu'
import GasMenu from './GasMenu'
import Map from '../components/Map'
import { stationsInit } from '../store/graphs/actions'
import * as graphSelectors from '../store/graphs/reducer'


class App extends Component {

  componentWillMount(){
    this.props.dispatch(stationsInit())
  }

  componentDidMount(){
    document.title = "BlickV"
  }

   render() {
    if(Object.keys(this.props.stations).length === 0 )
      return null

   return (
      <div className="App-wrapper">
      <div className='App'>
      <div className='App-title-header'>
        <a className="App-brand" href="https://www.pandonia-global-network.org/" aria-label="Pandonia Global Network home">
          <img src={pgnLogo} alt="Pandonia Global Network (PGN)" width="80" height="80" />
        </a>
        <div>
        <h1>BlickV</h1>
        <p>Pandonia Global Network · Data Visualization</p>
        </div>
      </div>
      <div className='Header'>

      <Map />
      <Menu />
      </div>

      <p className="measurements-scroll-hint">Scroll horizontally to see all products and dates.</p>
      <div className="measurements-scroll" role="region" aria-label="Gas measurements" tabIndex="0">
        <div className="measurements" style={{'--graph-width': `${GRAPH_SIZE[0]}px`, '--product-count': NUM_PRODUCTS}}>
          <GasMenu/>
          <GraphBlock/>
        </div>
      </div>

      </div>
      </div>
   )
   }
}

function mapStateToProps(state) {
  const stations = graphSelectors.getStationList(state)
  return {
    stations: stations,
  }
}


export default connect(mapStateToProps)(App)







